import { useContext } from 'react'
import OrderContext from '../contexts/order-context'

const useOrderContext = () => {
  return useContext(OrderContext)
}

export default useOrderContext
